import { createSlot } from "lib/@components/slot/create-slot"

/**
 * Views of a skill map beside Skill routing. Plug a <SkillMapViewMode value label> holding
 * the view's content: the skill map view adds a toggle for each one plugged (and whose `if`
 * passes) and shows the chosen one's content in place of skill routing.
 */
export const SkillMapViewModes = createSlot("SkillMapViewModes")

/** Above the skill routing list, below the view toggle */
export const SkillMapSkillRoutingTop = createSlot("SkillMapSkillRoutingTop")

/**
 * On each skill routing trade row, after its skills (the row is the bound target). A plug
 * replaces the row's own "No skills" label, so it must say so itself when that applies.
 */
export const SkillMapTradeRowExtra = createSlot("SkillMapTradeRowExtra")
